
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Kiacarensonrentforcorporateinpune() {



    const cardData =
    {
        keyword: 'Kia Carens On Rent for Corporate in Pune   ',
        heading: 'etravo : Kia Carens On Rent for Corporate in Pune  ',



"headingDescription": "eTravo offers reliable Kia Carens on Rent for Corporate Travel in Pune, designed for companies, IT firms, and business teams who need spacious and comfortable group transportation. The Kia Carens is ideal for employee pickup and drop, airport transfers, client meetings, and small team outstation trips. With premium seating for up to 6–7 passengers, GPS-enabled vehicles, and professional chauffeurs, eTravo ensures safe, punctual, and smooth corporate travel across Pune.",

"top": "Top Corporate Use Cases for Kia Carens in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Ideal for shift-based employee transportation and group commute for IT companies and MNCs in Pune’s largest tech hub."
  },
  {
    "title": "Kharadi IT Park",
    "description": "Widely used for daily office pickup and drop services for employees working in EON IT Park and nearby corporate offices."
  },
  {
    "title": "Magarpatta City",
    "description": "A structured IT township where Kia Carens is preferred for comfortable and organized employee transport services."
  },
  {
    "title": "Hadapsar",
    "description": "A key industrial and IT zone where Kia Carens is used for cost-effective and comfortable corporate commuting."
  },
  {
    "title": "Baner-Balewadi",
    "description": "A fast-growing corporate hub where startups and offices use Kia Carens for executive travel and small team movement."
  },
  {
    "title": "Viman Nagar",
    "description": "A prime location near Pune Airport, making Kia Carens ideal for airport transfers and corporate guest pickup."
  },
  {
    "title": "Wakad",
    "description": "A major residential hub for IT employees where Kia Carens is used for daily office commute to Hinjewadi."
  },
  {
    "title": "Koregaon Park",
    "description": "A premium locality where Kia Carens is used for business meetings, client visits, and executive transport."
  },
  {
    "title": "Shivajinagar",
    "description": "Central business district where Kia Carens supports official visits and corporate travel needs."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "Industrial zone where Kia Carens is used for employee transport, factory visits, and workforce movement."
  }
],


"services": [
{
"name": "Kia Carens Hire Pune",
"description": "eTravo offers Kia Carens hire in Pune for comfortable and spacious travel. Ideal for families and corporate groups, our vehicles ensure smooth rides with professional chauffeurs and well-maintained interiors."
},
{
"name": "Kia Carens Cab Pune",
"description": "Our Kia Carens cab services in Pune provide reliable and comfortable transportation for daily commuting and outstation travel. eTravo ensures punctual service and a premium travel experience."
},
{
"name": "Kia Carens Rental Pune",
"description": "eTravo provides Kia Carens rental services in Pune with flexible booking options. Our vehicles are perfect for business trips, family outings, and group travel with ample space and comfort."
},
{
"name": "Kia Carens Taxi Pune",
"description": "Choose Kia Carens taxi services in Pune by eTravo for smooth and hassle-free travel. Our taxis are equipped for comfort and driven by experienced chauffeurs for a safe journey."
},
{
"name": "Corporate Kia Carens Pune",
"description": "eTravo offers Kia Carens for corporate use in Pune, ensuring efficient and comfortable employee transport. Our service is ideal for office commuting, meetings, and business travel."
},
{
"name": "Kia Carens Booking Pune",
"description": "Book a Kia Carens in Pune easily with eTravo. Our simple booking process and reliable service ensure a seamless travel experience for all your transportation needs."
},
{
"name": "Kia Carens Company Cab Pune",
"description": "eTravo provides Kia Carens company cab services in Pune tailored for employee commuting and corporate travel. Our service ensures comfort, punctuality, and professional travel solutions."
},
{
"name": "Kia Carens Travel Pune",
"description": "Our Kia Carens travel services in Pune are designed for smooth and comfortable journeys. Whether for business or personal trips, eTravo ensures a pleasant travel experience."
},
{
"name": "Kia Carens Fleet Pune",
"description": "eTravo offers Kia Carens fleet services in Pune for businesses requiring multiple vehicles. Our fleet ensures consistent quality, proper maintenance, and reliable transportation."
},
{
"name": "Kia Carens Office Use Pune",
"description": "eTravo provides Kia Carens vehicles for office use in Pune, offering reliable and comfortable transportation for employees. Our service supports daily commuting and corporate travel needs."
},
{
"name": "Kia Carens Cab Service Pune",
"description": "Our Kia Carens cab services in Pune ensure safe, comfortable, and efficient travel. eTravo provides well-maintained vehicles and professional drivers for a smooth journey."
},
{
"name": "Kia Carens Hire Service Pune",
"description": "eTravo’s Kia Carens hire services in Pune offer flexible and dependable transport solutions. Our service is ideal for both short-term and long-term travel requirements."
},
{
"name": "Kia Carens Employee Transport Pune",
"description": "eTravo provides Kia Carens employee transport services in Pune for safe and efficient commuting. Our service ensures punctual pickups and comfortable rides for the workforce."
},
{
"name": "Kia Carens Rental Service Pune",
"description": "Our Kia Carens rental services in Pune are designed for convenience and comfort. eTravo ensures quality vehicles and professional service for all travel needs."
},
{
"name": "Kia Carens Corporate Travel Pune",
"description": "eTravo offers Kia Carens corporate travel services in Pune for business trips and executive travel. Our service ensures reliability, comfort, and a professional travel experience."
}
],
"tableData": [
["Kia Carens Hire Pune", "Kia Carens Cab Pune"],
["Kia Carens Rental Pune", "Kia Carens Taxi Pune"],
["Corporate Kia Carens Pune", "Kia Carens Booking Pune"],
["Kia Carens Company Cab Pune", "Kia Carens Travel Pune"],
["Kia Carens Fleet Pune", "Kia Carens Office Use Pune"],
["Kia Carens Cab Service Pune", "Kia Carens Hire Service Pune"],
["Kia Carens Employee Transport Pune", "Kia Carens Rental Service Pune"],
["Kia Carens Corporate Travel Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Best Kia Carens On Rent for Corporate in Pune",
      "WhyChoosedescription": "eTravo offers reliable Kia Carens rental for corporate in Pune, providing a perfect combination of comfort, space, and premium features for employee transport and executive travel."
    },
    {
      "WhyChooseheading": "Spacious 6+1 / 7-Seater for Team Travel",
      "WhyChoosedescription": "Kia Carens is a spacious multi-utility vehicle with seating for 6 to 7 passengers, making it ideal for corporate teams, group travel, and airport transfers. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Ideal for Corporate and Executive Use",
      "WhyChoosedescription": "Carens is widely used for business meetings, client pickups, and daily office commutes, offering a premium and professional travel experience."
    },
    {
      "WhyChooseheading": "Comfort-Focused Premium Interiors",
      "WhyChoosedescription": "With features like rear AC vents, comfortable seating, and modern infotainment systems, Kia Carens ensures a smooth and relaxing journey for employees and executives. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Fuel-Efficient and Cost-Effective Option",
      "WhyChoosedescription": "Kia Carens offers good mileage and efficient performance, making it a cost-effective solution for corporate travel needs. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "Professional Chauffeur-Driven Service",
      "WhyChoosedescription": "Our trained chauffeurs ensure punctual, safe, and professional travel with complete knowledge of Pune routes and corporate travel requirements."
    },
    {
      "WhyChooseheading": "Flexible Rental Plans for Corporate Clients",
      "WhyChoosedescription": "eTravo provides hourly, daily, monthly, and long-term rental plans for Kia Carens, allowing businesses to customize travel based on their operational needs."
    },
    {
      "WhyChooseheading": "24/7 Support for Corporate Travel",
      "WhyChoosedescription": "Our dedicated support team is available round the clock to handle bookings, last-minute changes, and urgent corporate travel requirements."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is Kia Carens rental for corporate in Pune?',
            answer: 'Kia Carens rental for corporate in Pune is a chauffeur-driven cab service offering a spacious and comfortable vehicle for employee transport, meetings, and business travel.',
        },
        {
            question: 'Is Kia Carens suitable for corporate travel?',
            answer: 'Yes, Kia Carens is a 6/7-seater vehicle with premium features, making it ideal for corporate team travel and executive transportation. :contentReference[oaicite:3]{index=3}',
        },
        {
            question: 'How many passengers can Kia Carens accommodate?',
            answer: 'Kia Carens can accommodate 6 to 7 passengers comfortably, making it perfect for group travel and office commute. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'Can I book Kia Carens for airport transfers in Pune?',
            answer: 'Yes, Kia Carens is widely used for airport pickup and drop services for corporate employees and business clients.',
        },
        {
            question: 'Do Kia Carens rentals include a driver?',
            answer: 'Yes, all Kia Carens rentals come with professional chauffeur-driven service.',
        },
        {
            question: 'Is Kia Carens available for outstation corporate travel?',
            answer: 'Yes, you can book Kia Carens for both local and outstation corporate trips including one-way and round trips.',
        },
        {
            question: 'Are monthly Kia Carens rental plans available?',
            answer: 'Yes, eTravo offers monthly and long-term rental plans for corporate clients.',
        },
        {
            question: 'Is Kia Carens a cost-effective corporate vehicle?',
            answer: 'Yes, it provides a balance of space, comfort, and fuel efficiency, making it an economical choice for businesses. :contentReference[oaicite:5]{index=5}',
        },
        {
            question: 'Are Kia Carens vehicles well-maintained?',
            answer: 'Yes, all vehicles are regularly serviced, cleaned, and sanitized to ensure safety and comfort.',
        },
        {
            question: 'How can I book Kia Carens on rent for corporate in Pune?',
            answer: 'You can book online or contact the support team for quick and customized corporate travel arrangements.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amit Deshmukh',
        designation: 'Admin Manager, IT Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s Kia Carens rental is perfect for our corporate team travel. It’s spacious, comfortable, and always on time.”',
    },
    {
        name: 'Ms. Neha Sharma',
        designation: 'HR Executive, Corporate Firm, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We use Kia Carens for employee pickup and drop. The service is reliable, and the vehicle is very comfortable for daily commute.”',
    },
];









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kia Carens On Rent for Corporate in Pune",
  "image": "https://www.etravo.in/images/keyword/kia-carens-rent-pune.jpg",
  "description": "Comfortable Kia Carens on rent for corporate use in Pune by eTravo. Ideal for employee transport, office travel, staff pickup and drop, and business trips with spacious and premium seating.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/kia-carens-on-rent-for-corporate-in-pune"
  }
};







    return (
        <div>


<Helmet>
  <title>Kia Carens On Rent for Corporate in Pune | Premium Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Book Kia Carens on rent for corporate use in Pune with eTravo for employee transport, office travel, and business trips. Spacious, comfortable, and reliable cab service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/136.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kiacarensonrentforcorporateinpune;